"use client";

import * as React from "react";

import { cn } from "@/lib/utils";

import type { FAQCategory } from "./faq-data";

// Offset to account for fixed header height when scrolling to sections
const HEADER_OFFSET_PX = 96;

interface FAQSidebarProps {
  categories: FAQCategory[];
  activeCategory: string | null;
  className?: string;
}

export default function FAQSidebar({
  categories,
  activeCategory,
  className,
}: FAQSidebarProps) {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition =
        elementPosition + window.scrollY - HEADER_OFFSET_PX;
      window.scrollTo({ top: offsetPosition, behavior: "smooth" });
    }
  };

  return (
    <nav className={cn("space-y-1", className)}>
      <p className="text-muted-foreground mb-4 text-xs font-medium tracking-wider uppercase">
        Categories
      </p>
      <div className="flex flex-col gap-1">
        {categories.map((category) => (
          <button
            key={category.id}
            onClick={() => {
              scrollToSection(category.id);
            }}
            className={cn(
              "cursor-pointer rounded-lg px-3 py-2 text-left text-sm transition-colors",
              category.id === activeCategory
                ? "bg-muted text-foreground font-medium"
                : "text-muted-foreground hover:bg-muted/50 hover:text-foreground",
            )}
          >
            <span className="block">{category.name}</span>
            <span className="text-muted-foreground block text-xs">
              {category.items.length} questions
            </span>
          </button>
        ))}
      </div>
    </nav>
  );
}
